module.exports = __webpack_public_path__ + "img/case-defaultimg.6cf390bc.png";